import { boot } from 'quasar/wrappers';
import { createConfig, http, WagmiPlugin } from '@wagmi/vue';
import { bsc, mainnet, polygon } from '@wagmi/vue/chains';
import { metaMask, walletConnect } from '@wagmi/vue/connectors';

declare module '@wagmi/vue' {
  interface Register {
    config: typeof config;
  }
}

export const config = createConfig({
  chains: [bsc, mainnet, polygon],
  transports: {
    [bsc.id]: http(
      'https://bsc-mainnet.infura.io/v3/42e468c88c35426fb14e957279bfc5aa',
    ),
    [mainnet.id]: http(
      'https://mainnet.infura.io/v3/42e468c88c35426fb14e957279bfc5aa',
    ),
    [polygon.id]: http(
      'https://polygon-mainnet.infura.io/v3/42e468c88c35426fb14e957279bfc5aa',
    ),
  },
  connectors: [
    metaMask(),
    walletConnect({
      showQrModal: true,
      projectId: process.env.WALLET_CONNECT_PROJECT_ID as string,
      metadata: {
        name: 'Presale | DOL',
        description: 'Presale | DOL',
        url: 'https://presale.dollum.com/',
        icons: ['https://presale.dollum.com/favicon.ico'],
      },
      qrModalOptions: {
        themeMode: 'dark',
        themeVariables: {
          '--wcm-z-index': '9999999',
        },
      },
    }),
  ],
});

export default boot(({ app }) => {
  app.use(WagmiPlugin, { config });
});
